'use client';

// Transporte entre écrans d'auth : l'e-mail en cours (inscription → vérification,
// oubli → reset) et un message « flash » de succès (ex. après reset → sign-in).

import { create } from 'zustand';

interface AuthFlowState {
  pendingEmail: string | null;
  setPendingEmail: (email: string | null) => void;
  /** Clé i18n (namespace auth) d'un message de succès à afficher sur l'écran suivant. */
  flash: string | null;
  setFlash: (key: string | null) => void;
}

export const useAuthFlow = create<AuthFlowState>((set) => ({
  pendingEmail: null,
  setPendingEmail: (email) => set({ pendingEmail: email }),
  flash: null,
  setFlash: (key) => set({ flash: key }),
}));
